exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\napp-post-item{\r\n    background-color: #fff !important;\r\n    border: 1px solid #e0e2e4;\r\n    border-radius: 3px;\r\n}\r\n\r\napp-comment-loader{\r\n    background-color: #fff !important;\r\n}\r\n\r\n.post-profile{\r\n    border: unset !important;\r\n    background-color:#fafafa !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/post-profile/post-profile.component.css
// module id = ../../../../../src/app/pages/post-profile/post-profile.component.css
// module chunks = main